// Default content for the immersive Home page. The Admin CMS overrides this per section.
export const DEFAULT_HOME = {
  hero: {
    badges: ["Peptides", "Science", "Longevity"],
    title: "Experience the|future of human|potential.",
    subtitle: "Precision peptides. Extraordinary performance.\nDeep regeneration. A longer, sharper you.",
    primary_label: "Enter the Lab",
    primary_link: "/shop",
    secondary_label: "Watch our story",
    secondary_link: "/journal",
    bg_image: "/img/lab-helix.jpg",
    sidewords_left: ["Science", "Longevity", "Performance", "A Higher You"],
    sidewords_right: ["Cellular Health", "Metabolic Optimization", "Cognitive Performance", "Longevity Protocols"],
  },
  cases: {
    eyebrow: "Storage · Engineered",
    title: "Peptide Cases",
    intro: "Pharmacist-designed vial cases that keep your peptides and bac water safe, organized and cold-chain ready.",
    cta_label: "Shop All Cases",
    cta_link: "/shop/cases",
    bg_image: "/img/lab-atom.jpg",
    badges: [
      { icon: "Snowflake", label: "Fridge & freezer safe" },
      { icon: "Lock", label: "Snap-secure lid" },
      { icon: "Ruler", label: "Fits 2–3mL vials" },
      { icon: "ShieldCheck", label: "Impact-resistant" },
    ],
  },
  method: {
    eyebrow: "Discover · Personalize · Transcend",
    title: "The CG Labz|Method",
    intro: "A precision approach to human optimization. Science, personalization and care — working together for a longer, sharper you.",
    cta_label: "Book a Consultation",
    cta_link: "/tools/match",
    bg_image: "/img/lab-atom.jpg",
    cards: [
      { title: "Lab Standards", desc: "Pharmaceutical-grade peptides. Rigorous testing. Uncompromising quality.", icon: "Atom", link: "/coa" },
      { title: "Human Performance", desc: "Focused on energy, cognition, recovery and longevity.", icon: "Brain", link: "/peptides" },
      { title: "Private Consultation", desc: "A tailored experience. Personalized protocols. Real results.", icon: "UserRound", link: "/tools/match" },
    ],
  },
  pathway: {
    panel_title: "Your Selected Pathway",
    title: "Premium Peptide|Solutions",
    subtitle: "Targeted science. Real results.",
    bg_image: "/img/lab-molecule.jpg",
    pathways: [
      { title: "Recovery", desc: "Rebuild. Restore. Perform. Accelerate recovery and reduce physical fatigue.", icon: "Leaf", category: "recovery" },
      { title: "Cognition", desc: "Sharpen focus. Enhance clarity. Support memory and mental performance.", icon: "Brain", category: "cognitive" },
      { title: "Longevity", desc: "Extend healthspan. Optimize vitality. Support cellular health.", icon: "Infinity", category: "longevity" },
      { title: "Metabolic Support", desc: "Activate balance. Fuel potential. Support healthy metabolism.", icon: "Flame", category: "metabolic" },
    ],
  },
  protocols: {
    eyebrow: "Science meets human potential",
    title: "Curated Protocols",
    intro: "Precision formulations for a longer, sharper, more extraordinary you.",
    bg_image: "/img/lab-4.jpg",
    items: [
      { title: "Elite Recovery", desc: "Rebuild faster. Go further. Recover at a higher level.", icon: "Sparkles", category: "recovery", image: "/img/gen-body.jpg" },
      { title: "Cognitive Edge", desc: "Sharper thinking. Clearer tomorrows.", icon: "Brain", category: "cognitive", image: "/img/gen-brain.jpg" },
      { title: "Ultimate Vitality", desc: "More energy. Greater balance. A more vibrant you.", icon: "HeartPulse", category: "longevity", image: "/img/raw-helix.jpg" },
      { title: "Longevity Reset", desc: "Cellular renewal for a longer, fuller life.", icon: "Dna", category: "longevity", image: "/img/gen-atom.jpg" },
      { title: "Performance Prime", desc: "Peak performance. Without limits.", icon: "Activity", category: "performance", image: "/img/raw-mol.jpg" },
    ],
  },
  science: {
    title: "Precision science.|Visible transformation.",
    subtitle: "Peptides for a higher you",
    bg_image: "/img/lab-helix.jpg",
    items: [
      { title: "Regeneration", desc: "Accelerate cellular repair and tissue renewal.", icon: "Atom", link: "/peptides?category=recovery" },
      { title: "Neuro-Enhancement", desc: "Sharpen cognition, focus and mental performance.", icon: "Brain", link: "/peptides?category=cognitive" },
      { title: "Metabolic Optimization", desc: "Support healthy metabolism and body composition.", icon: "Flame", link: "/peptides?category=metabolic" },
      { title: "Anti-Aging", desc: "Activate longevity pathways for a stronger tomorrow.", icon: "Infinity", link: "/peptides?category=longevity" },
    ],
  },
  tools: {
    eyebrow: "Lab instruments",
    title: "Research Tools",
    items: [
      { title: "Precision Calculator", desc: "Concentration arithmetic, visualized.", link: "/tools/calculator" },
      { title: "Compare Engine", desc: "Up to 4 peptides, side by side.", link: "/tools/compare" },
      { title: "Research Match", desc: "Discover what to research next.", link: "/tools/match" },
      { title: "COA Library", desc: "Every batch. Verified.", link: "/coa" },
    ],
  },
};

export const HOME_SECTIONS = ["hero", "cases", "method", "pathway", "protocols", "science", "tools"];

export const mergeHome = (c = {}) => {
  const out = {};
  for (const k of Object.keys(DEFAULT_HOME)) {
    const d = DEFAULT_HOME[k];
    const v = c && c[k];
    out[k] = v && typeof v === "object" && !Array.isArray(v) ? { ...d, ...v } : (v ?? d);
  }
  return out;
};
